"use client";

import { SearchInput } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import * as React from "react";

function Container({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  return (
    <div
      className={cn(
        "flex items-center border-b flex-wrap border-border gap-3 px-4 py-3",
        className,
      )}
      {...props}
    />
  );
}

function Separator({
  className,
  ...props
}: React.ComponentPropsWithoutRef<"div">) {
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      className={cn("w-px h-2/3 min-h-4 md:block hidden shrink-0 bg-contrast/10", className)}
      {...props}
    />
  );
}

export interface ToolbarSearchProps
  extends Omit<React.ComponentProps<typeof SearchInput>, "onChange" | "type"> {
  onChange: (value: string) => void;
}

function Search({
  value,
  onChange,
  placeholder = "Search",
  className = "w-[180px]",
  ...props
}: ToolbarSearchProps) {
  return (
    <SearchInput
      {...props}
      placeholder={placeholder}
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export const Toolbar = {
  Container,
  Separator,
  Search,
};
